import { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, ArrowRight, Sparkles, Check, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// Real social media logos as SVG components
const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const PinterestIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
    <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const platforms = [
  { name: "Instagram", Icon: InstagramIcon, color: "from-pink-500 via-purple-500 to-orange-400", textColor: "text-white" },
  { name: "Facebook", Icon: FacebookIcon, color: "from-blue-600 to-blue-700", textColor: "text-white" },
  { name: "TikTok", Icon: TikTokIcon, color: "from-gray-900 to-black", textColor: "text-white" },
  { name: "Twitter/X", Icon: TwitterIcon, color: "from-gray-900 to-black", textColor: "text-white" },
  { name: "Pinterest", Icon: PinterestIcon, color: "from-red-600 to-red-700", textColor: "text-white" },
  { name: "LinkedIn", Icon: LinkedInIcon, color: "from-blue-700 to-blue-800", textColor: "text-white" },
];

const features = [
  "Templates prédéfinis professionnels",
  "Génération IA optimisée par plateforme",
  "Partage direct vers les réseaux sociaux",
  "Export en masse ZIP (PNG/JPG/WebP)",
];

export const AdStudioSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredPlatform, setHoveredPlatform] = useState<string | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 relative overflow-hidden" id="ad-studio">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-accent/5 to-background" />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent/50 to-transparent" />
      
      {/* Animated decorative elements */}
      <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-gradient-to-br from-pink-500/10 via-purple-500/10 to-orange-500/10 blur-[120px] rounded-full animate-pulse" />
      <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-gradient-to-br from-blue-500/10 via-cyan-500/10 to-teal-500/10 blur-[120px] rounded-full animate-pulse" style={{ animationDelay: "1s" }} />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section header */}
        <div className={cn(
          "text-center mb-16 transition-all duration-700",
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        )}>
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-orange-500/20 border border-accent/30 rounded-full px-5 py-2.5 mb-6">
            <Sparkles className="w-4 h-4 text-accent animate-pulse" />
            <span className="text-sm font-bold bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500 bg-clip-text text-transparent">
              NOUVEAU
            </span>
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 font-display">
            <span className="bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500 bg-clip-text text-transparent">
              Ad Creative Studio
            </span>
          </h2>
          
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Créez et publiez des publicités professionnelles sur tous les réseaux sociaux en quelques clics
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Left - Platforms showcase */}
          <div className={cn(
            "relative transition-all duration-700 delay-200",
            isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
          )}>
            <div className="relative">
              {/* Main card */}
              <div className="bg-card/80 backdrop-blur-xl border border-border rounded-3xl p-8 shadow-2xl">
                <div className="flex items-center justify-between mb-8">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 flex items-center justify-center shadow-lg shadow-purple-500/30">
                      <Megaphone className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg text-foreground">Plateformes supportées</h3>
                      <p className="text-sm text-muted-foreground">Cliquez pour prévisualiser</p>
                    </div>
                  </div>
                  <span className="bg-success/20 text-success text-xs font-bold px-3 py-1 rounded-full">
                    6 réseaux
                  </span>
                </div>

                {/* Platforms grid with real logos */}
                <div className="grid grid-cols-3 gap-4">
                  {platforms.map((platform, i) => (
                    <div
                      key={platform.name}
                      className={cn(
                        "relative group cursor-pointer transition-all duration-500",
                        isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"
                      )}
                      style={{ transitionDelay: `${400 + i * 100}ms` }}
                      onMouseEnter={() => setHoveredPlatform(platform.name)}
                      onMouseLeave={() => setHoveredPlatform(null)}
                    >
                      <div className={cn(
                        "relative p-5 rounded-2xl border transition-all duration-300 overflow-hidden",
                        hoveredPlatform === platform.name 
                          ? "border-transparent scale-105 shadow-xl" 
                          : "border-border bg-secondary/30 hover:border-primary/30"
                      )}>
                        {/* Gradient background on hover */}
                        <div className={cn(
                          "absolute inset-0 bg-gradient-to-br transition-opacity duration-300",
                          platform.color,
                          hoveredPlatform === platform.name ? "opacity-100" : "opacity-0"
                        )} />
                        
                        <div className="relative z-10 flex flex-col items-center gap-3">
                          <div className={cn(
                            "transition-all duration-300",
                            hoveredPlatform === platform.name ? platform.textColor : "text-foreground"
                          )}>
                            <platform.Icon />
                          </div>
                          <span className={cn(
                            "text-xs font-semibold transition-colors duration-300",
                            hoveredPlatform === platform.name ? platform.textColor : "text-foreground"
                          )}>
                            {platform.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Stats bar */}
                <div className="mt-8 pt-6 border-t border-border grid grid-cols-3 gap-4">
                  <div className="text-center">
                    <p className="text-3xl font-bold bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">8+</p>
                    <p className="text-xs text-muted-foreground mt-1">Templates pro</p>
                  </div>
                  <div className="text-center">
                    <p className="text-3xl font-bold bg-gradient-to-r from-purple-500 to-blue-500 bg-clip-text text-transparent">~5s</p>
                    <p className="text-xs text-muted-foreground mt-1">Génération</p>
                  </div>
                  <div className="text-center">
                    <p className="text-3xl font-bold bg-gradient-to-r from-blue-500 to-cyan-500 bg-clip-text text-transparent">10</p>
                    <p className="text-xs text-muted-foreground mt-1">Crédits/pub</p>
                  </div>
                </div>
              </div>

              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg shadow-purple-500/30 animate-bounce">
                🎉 NOUVEAU
              </div>
              
              <div className="absolute -bottom-3 -left-3 bg-card border border-border rounded-2xl px-4 py-3 shadow-lg flex items-center gap-2">
                <Zap className="w-4 h-4 text-highlight" />
                <span className="text-sm font-medium text-foreground">Partage direct activé</span>
              </div>
            </div>
          </div>

          {/* Right content */}
          <div className={cn(
            "transition-all duration-700 delay-400",
            isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
          )}>
            <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-6">
              Créez, Publiez, <span className="bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">Convertissez</span>
            </h3>
            
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Uploadez votre produit, choisissez vos plateformes cibles, et laissez notre IA générer des publicités optimisées. 
              Partagez directement sur vos réseaux sociaux ou téléchargez en masse.
            </p>

            {/* Features list */}
            <ul className="space-y-4 mb-10">
              {features.map((feature, i) => (
                <li 
                  key={i}
                  className={cn(
                    "flex items-center gap-4 transition-all duration-500",
                    isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"
                  )}
                  style={{ transitionDelay: `${600 + i * 100}ms` }}
                >
                  <div className="w-6 h-6 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center flex-shrink-0 shadow-lg shadow-purple-500/30">
                    <Check className="w-3.5 h-3.5 text-white" />
                  </div>
                  <span className="text-foreground font-medium">{feature}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <div className="flex flex-wrap gap-4 items-center">
              <Link to="/ad-studio">
                <Button size="lg" className="bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500 hover:opacity-90 text-white rounded-full px-8 shadow-xl shadow-purple-500/30 group text-base">
                  <Megaphone className="w-5 h-5 mr-2" />
                  Créer ma première pub
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link to="/ad-history" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Voir les exemples →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
